import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";

interface Props {
    children : React.ReactNode,
    setAuthentication: (val: boolean) => void;
}

const SettingFileView = ({children, setAuthentication}:Props) => {
  const [settingsFile, setSettingsFile] = useState("");
  const [isSuccess, setIsSuccess] = useState(checkLocalStorage());

  let fileReader: FileReader;

  function checkLocalStorage() {
    const model = SettingsFromLocalStorage();
    return model.apiKey && model.apiKey !== "" ? true : false;
  }

  const changeHandler = (event: any) => {
    try {
      fileReader = new FileReader();
      fileReader.onloadend = (evt: any) => {
        setSettingsFile(evt.target.result ?? "");
      };
      fileReader.readAsText(event.target.files[0]);
    } catch (error) {
      // console.log(error);
    }
  };

  function saveCredentials(model: SettingsCredential) {
    if (model.apiKey) {
      Object.entries(model).map((e, idx) => localStorage.setItem(e[0], e[1]));
      setIsSuccess(true);
    }
  }

  const settingsCredentials =
    settingsFile && SettingsFromJson(JSON.parse(settingsFile));

  return (
    <div className="flex flex-col gap-4">
      {isSuccess ? (
        <>
          <div className="w-full  p-2 rounded-md justify-between flex flex-col md:flex-row items-start md:items-center">
            <div className="inline-flex flex-row gap-2 text-green-700">
              <span className="">
                <FontAwesomeIcon icon={faCheck} />
              </span>
              <span>Setting file</span>
            </div>

            <button
              onClick={() => {
                setIsSuccess(false);
                setSettingsFile("");
                setAuthentication(false);
                localStorage.clear();
                
              }}
              className="flex flex-row gap-2 text-red-700 hover:bg-red-100 bg-red-200 rounded-lg p-2"
            >
              <span className="">
                <FontAwesomeIcon icon={faTimes} />
              </span>

              <span>{'Logout & Clear Settings'}</span>
            </button>
          </div>
          {children}
        </>
      ) : (
        <>
          <div className="w-full bg-yellow-200 p-2 rounded-md">
            You need to set your settings.
          </div>

          <input
            type="file"
            name="file"
            accept="application/json"
            onChange={changeHandler}
          />

          <div>
            <button
              className="p-2 text-light bg-primary hover:bg-secondary "
              onClick={() => {
                settingsCredentials && saveCredentials(settingsCredentials);
              }}
            >
              Submit
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default SettingFileView;

export type SettingsCredential = {
  apiKey: string;
  authDomain: string;
  databaseURL: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId: string;
};

export function SettingsFromJson(json: { [key: string]: any }) {
  const data = {
    apiKey: json["apiKey"],
    authDomain: json["authDomain"],
    databaseURL: json["databaseURL"],
    projectId: json["projectId"],
    storageBucket: json["storageBucket"],
    messagingSenderId: json["messagingSenderId"],
    appId: json["appId"],
    measurementId: json["measurementId"],
  };

  return data;
}

export function SettingsFromLocalStorage() {
  const data: SettingsCredential = {
    apiKey: localStorage.getItem("apiKey") ?? "",
    authDomain: localStorage.getItem("authDomain") ?? "",
    databaseURL: localStorage.getItem("databaseURL") ?? "",
    projectId: localStorage.getItem("projectId") ?? "",
    storageBucket: localStorage.getItem("storageBucket") ?? "",
    messagingSenderId: localStorage.getItem("messagingSenderId") ?? "",
    appId: localStorage.getItem("appId") ?? "",
    measurementId: localStorage.getItem("measurementId") ?? "",
  };
  return data;
}
